import { ReactNode } from "react";
import { SubNav, SubNavTab } from "@/components/layout/SubNav";

interface FieldsLayoutProps {
  children: ReactNode;
  onRefresh?: () => void;
  isRefreshing?: boolean;
}

const fieldsTabs: SubNavTab[] = [
  { label: "Field Mappings", path: "/fields/mappings" },
  { label: "Choice Mappings", path: "/fields/choice-mappings" },
  { label: "Field Sync", path: "/fields/field-sync" },
  { label: "Sync Logs", path: "/fields/logs" },
  { label: "Auto-Discovery", path: "/fields/auto-discovery" },
];

export const FieldsLayout = ({ children, onRefresh, isRefreshing }: FieldsLayoutProps) => {
  return (
    <div className="flex flex-col h-full">
      <SubNav tabs={fieldsTabs} onRefresh={onRefresh} isRefreshing={isRefreshing} />
      <main className="flex-1 overflow-y-auto bg-[#F5F5F5]">
        {children}
      </main>
    </div>
  );
};
